import React, { useEffect, useState, useRef } from 'react';
import { UploadIcon, CheckCircleIcon, ClockIcon, MailIcon, RefreshCwIcon, DownloadIcon, XIcon, UsersIcon, UserCheckIcon, ShieldCheckIcon, AlertCircleIcon, TrendingUpIcon } from 'lucide-react';
interface Supplier {
  id: string;
  name: string;
  email: string;
  paymentTerms: string;
  inviteSent: boolean;
  status: 'invited' | 'pending' | 'active';
  lastActivity: string;
  fundingActivity: string;
  source?: 'seed' | 'csv' | 'erp';
}
// Seeded suppliers - 12 invited (2 active, 3 pending, 7 invited)
const SEEDED_ACTIVATED_SUPPLIERS: Supplier[] = [{
  id: 'seed-001',
  name: 'Premium Textiles Inc',
  email: 'ap@premiumtextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-15',
  fundingActivity: 'Accepted 2 offers this week',
  source: 'seed'
}, {
  id: 'seed-002',
  name: 'Global Apparel Wholesale',
  email: 'billing@globalapparel.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'active',
  lastActivity: '2025-01-14',
  fundingActivity: 'Consistent usage',
  source: 'seed'
}, {
  id: 'seed-003',
  name: 'Fashion Forward Distributors',
  email: 'accounts@fashionforward.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-14',
  fundingActivity: 'Accepted initial advance',
  source: 'seed'
}, {
  id: 'seed-004',
  name: 'Metro Fabric Supply',
  email: 'payables@metrofabric.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-13',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-005',
  name: 'Coastal Textiles Group',
  email: 'finance@coastaltextiles.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'pending',
  lastActivity: '2025-01-12',
  fundingActivity: 'No funding yet',
  source: 'seed'
}, {
  id: 'seed-006',
  name: 'Riverside Manufacturing Co',
  email: 'ap@riversidemanufacturing.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-11',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-007',
  name: 'Northern Logistics Partners',
  email: 'billing@northernlogistics.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-10',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-008',
  name: 'Eastern Supply Chain Co',
  email: 'ap@easternsupply.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-09',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-009',
  name: 'Western Materials Group',
  email: 'accounts@westernmaterials.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-08',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-010',
  name: 'Southern Wholesale Inc',
  email: 'finance@southernwholesale.com',
  paymentTerms: 'Net 45',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-07',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-011',
  name: 'Central Trading Partners',
  email: 'payables@centraltrading.com',
  paymentTerms: 'Net 60',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-06',
  fundingActivity: '—',
  source: 'seed'
}, {
  id: 'seed-012',
  name: 'Pacific Distribution LLC',
  email: 'billing@pacificdist.com',
  paymentTerms: 'Net 30',
  inviteSent: true,
  status: 'invited',
  lastActivity: '2025-01-05',
  fundingActivity: '—',
  source: 'seed'
}];
// CSV suppliers - different from seeded ones
const CSV_SUPPLIERS: Supplier[] = [{
  id: 'csv-001',
  name: 'Apex Materials Corp',
  email: 'billing@apexmaterials.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-002',
  name: 'Delta Supply Chain Solutions',
  email: 'accounts@deltasupply.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}, {
  id: 'csv-003',
  name: 'Horizon Trading Partners',
  email: 'ap@horizontrading.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'csv'
}];
// ERP suppliers - different from both seeded and CSV
const ERP_SUPPLIERS: Supplier[] = [{
  id: 'erp-001',
  name: 'Pacific Home Goods',
  email: 'payables@pacifichome.com',
  paymentTerms: 'Net 45',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-002',
  name: 'Summit Office Supply',
  email: 'finance@summitoffice.com',
  paymentTerms: 'Net 60',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}, {
  id: 'erp-003',
  name: 'Omega Electronics Trading',
  email: 'ap@omegaelectronics.com',
  paymentTerms: 'Net 30',
  inviteSent: false,
  status: 'invited',
  lastActivity: '—',
  fundingActivity: '—',
  source: 'erp'
}];
export function AnchorPortal() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [activatedSuppliers, setActivatedSuppliers] = useState<Supplier[]>(SEEDED_ACTIVATED_SUPPLIERS);
  const [selectedSuppliers, setSelectedSuppliers] = useState<Set<string>>(new Set());
  const [showInviteSuccess, setShowInviteSuccess] = useState(false);
  const [showErpModal, setShowErpModal] = useState(false);
  const [csvSynced, setCsvSynced] = useState(false);
  const [erpSynced, setErpSynced] = useState(false);
  const [lastUploadTime, setLastUploadTime] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    document.title = 'Mint | Treasury';
  }, []);
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      setCsvSynced(true);
      const now = new Date();
      const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
      setLastUploadTime(timeStr);
      setTimeout(() => {
        setSuppliers(prev => [...prev, ...CSV_SUPPLIERS]);
      }, 500);
    }
  };
  const handleErpSync = (system: string) => {
    setShowErpModal(false);
    setErpSynced(true);
    setTimeout(() => {
      setSuppliers(prev => [...prev, ...ERP_SUPPLIERS]);
      setShowInviteSuccess(true);
      setTimeout(() => setShowInviteSuccess(false), 3000);
    }, 500);
  };
  const handleClearImported = () => {
    setSuppliers([]);
    setUploadedFile(null);
    setCsvSynced(false);
    setErpSynced(false);
    setLastUploadTime('');
    setSelectedSuppliers(new Set());
  };
  const handleSelectAll = () => {
    if (selectedSuppliers.size === suppliers.length) {
      setSelectedSuppliers(new Set());
    } else {
      setSelectedSuppliers(new Set(suppliers.map(s => s.id)));
    }
  };
  const handleSelectSupplier = (id: string) => {
    const newSelected = new Set(selectedSuppliers);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelectedSuppliers(newSelected);
  };
  const handleInviteSuppliers = () => {
    const invitedSuppliers = suppliers.filter(s => selectedSuppliers.has(s.id));
    const now = new Date().toISOString().split('T')[0];
    const newActivated = invitedSuppliers.map(supplier => ({
      ...supplier,
      inviteSent: true,
      status: 'invited' as const,
      lastActivity: now
    }));
    setActivatedSuppliers(prev => [...prev, ...newActivated]);
    setSuppliers(prev => prev.filter(s => !selectedSuppliers.has(s.id)));
    setSelectedSuppliers(new Set());
    setShowInviteSuccess(true);
    setTimeout(() => setShowInviteSuccess(false), 3000);
  };
  const getStatusBadge = (status: string) => {
    const styles = {
      invited: 'bg-blue-50 text-blue-700',
      pending: 'bg-yellow-50 text-yellow-700',
      active: 'bg-green-50 text-green-700'
    };
    return styles[status as keyof typeof styles] || styles.invited;
  };
  const invitedCount = activatedSuppliers.length;
  const pendingCount = activatedSuppliers.filter(s => s.status === 'pending').length;
  const activeCount = activatedSuppliers.filter(s => s.status === 'active').length;
  const csvSupplierCount = suppliers.filter(s => s.source === 'csv').length;
  const erpSupplierCount = suppliers.filter(s => s.source === 'erp').length;
  return <div className="min-h-screen bg-gray-50" data-id="element-804">
      <div className="max-w-7xl mx-auto" data-id="element-805">
        {/* Header */}
        <div className="mb-8" data-id="element-806">
          <h1 className="text-3xl font-semibold text-gray-900" data-id="element-807">Treasury</h1>
          <p className="text-gray-600 mt-1" data-id="element-808">Supplier Activation</p>
        </div>
        {/* Success Toast */}
        {showInviteSuccess && <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-center justify-between" data-id="element-809">
            <div className="flex items-center" data-id="element-810">
              <CheckCircleIcon size={20} className="text-green-600 mr-3" data-id="element-811" />
              <span className="text-sm text-green-800" data-id="element-812">
                Invitations sent successfully
              </span>
            </div>
            <button onClick={() => setShowInviteSuccess(false)} className="text-green-600 hover:text-green-700" data-id="element-813">
              <XIcon size={16} data-id="element-814" />
            </button>
          </div>}
        {/* Top Section: Activation Status + AI Intelligence */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-815">
          {/* Left: Supplier Activation Status */}
          <div className="col-span-2 bg-white rounded-lg border border-gray-200" data-id="element-816">
            <div className="p-6 border-b border-gray-200" data-id="element-817">
              <div className="flex items-center justify-between mb-6" data-id="element-818">
                <div data-id="element-819">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-820">
                    Supplier Activation Status
                  </h2>
                </div>
                <button className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-821">
                  <DownloadIcon size={16} className="mr-2" data-id="element-822" />
                  Export
                </button>
              </div>
              {/* Summary Cards */}
              <div className="grid grid-cols-3 gap-4" data-id="element-823">
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-824">
                  <div className="flex items-center justify-between" data-id="element-825">
                    <div data-id="element-826">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-827">
                        Suppliers Invited
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-828">
                        {invitedCount}
                      </div>
                    </div>
                    <UsersIcon size={24} className="text-gray-400" data-id="element-829" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-830">
                  <div className="flex items-center justify-between" data-id="element-831">
                    <div data-id="element-832">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-833">
                        Pending Activation
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-834">
                        {pendingCount}
                      </div>
                    </div>
                    <ClockIcon size={24} className="text-gray-400" data-id="element-835" />
                  </div>
                </div>
                <div className="bg-gray-50 rounded-lg p-4" data-id="element-836">
                  <div className="flex items-center justify-between" data-id="element-837">
                    <div data-id="element-838">
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-839">
                        Active Suppliers
                      </div>
                      <div className="text-2xl font-semibold text-gray-900" data-id="element-840">
                        {activeCount}
                      </div>
                    </div>
                    <UserCheckIcon size={24} className="text-gray-400" data-id="element-841" />
                  </div>
                </div>
              </div>
            </div>
            {/* Activation Table */}
            <div className="overflow-x-auto" data-id="element-842">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-843">
                <thead className="bg-gray-50" data-id="element-844">
                  <tr data-id="element-845">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-846">
                      Supplier Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-847">
                      Invite Sent
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-848">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-849">
                      Funding Activity
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-850">
                      Last Activity
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-851">
                  {activatedSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50" data-id="element-852">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-853">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-854">
                        <div className="flex items-center text-sm text-gray-600" data-id="element-855">
                          <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-856" />
                          Yes
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-857">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(supplier.status)}`} data-id="element-858">
                          {supplier.status === 'invited' && <MailIcon size={12} className="mr-1" data-id="element-859" />}
                          {supplier.status === 'pending' && <ClockIcon size={12} className="mr-1" data-id="element-860" />}
                          {supplier.status === 'active' && <CheckCircleIcon size={12} className="mr-1" data-id="element-861" />}
                          {supplier.status.charAt(0).toUpperCase() + supplier.status.slice(1)}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-862">
                        {supplier.fundingActivity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-863">
                        {supplier.lastActivity}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
          {/* Right: Mint Intelligence Overview */}
          <div className="space-y-4" data-id="element-864">
            <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2" data-id="element-865">
              Mint Intelligence Overview
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-866">
              <div className="flex items-start justify-between mb-3" data-id="element-867">
                <div data-id="element-868">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-869">
                    Invoices Validated
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-870">
                    100%
                  </div>
                </div>
                <ShieldCheckIcon size={20} className="text-green-600" data-id="element-871" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-872">
              <div className="flex items-start justify-between mb-3" data-id="element-873">
                <div data-id="element-874">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-875">
                    Buyer Legitimacy
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-876">
                    Stable
                  </div>
                </div>
                <CheckCircleIcon size={20} className="text-green-600" data-id="element-877" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-878">
              <div className="flex items-start justify-between mb-3" data-id="element-879">
                <div data-id="element-880">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-881">
                    Authenticity Score
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-882">
                    99.3%
                  </div>
                </div>
                <TrendingUpIcon size={20} className="text-green-600" data-id="element-883" />
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-884">
              <div className="flex items-start justify-between mb-3" data-id="element-885">
                <div data-id="element-886">
                  <div className="text-xs text-gray-500 uppercase tracking-wide mb-1" data-id="element-887">
                    Anomalies Detected
                  </div>
                  <div className="text-2xl font-semibold text-gray-900" data-id="element-888">0</div>
                </div>
                <AlertCircleIcon size={20} className="text-gray-400" data-id="element-889" />
              </div>
            </div>
          </div>
        </div>
        {/* Middle: Invite Suppliers Section */}
        <div className="bg-white rounded-lg border border-gray-200 mb-8" data-id="element-890">
          <div className="p-6 border-b border-gray-200" data-id="element-891">
            <div className="flex items-center justify-between" data-id="element-892">
              <div data-id="element-893">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-894">
                  Invite Suppliers
                </h2>
              </div>
              <div className="flex items-center gap-3" data-id="element-895">
                {suppliers.length > 0 && <button onClick={handleClearImported} className="text-sm text-gray-600 hover:text-gray-800 font-medium" data-id="element-896">
                    Clear imported list
                  </button>}
                {selectedSuppliers.size > 0 && <button onClick={handleInviteSuppliers} className="inline-flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-897">
                    <MailIcon size={16} className="mr-2" data-id="element-898" />
                    Invite {selectedSuppliers.size} Supplier
                    {selectedSuppliers.size > 1 ? 's' : ''}
                  </button>}
              </div>
            </div>
            {/* Upload Status Banners */}
            {csvSynced && csvSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-4 py-2" data-id="element-899">
                <div className="flex items-center text-sm text-blue-800" data-id="element-900">
                  <CheckCircleIcon size={16} className="text-blue-600 mr-2" data-id="element-901" />
                  Uploaded {uploadedFile?.name || 'Book2.csv'} with{' '}
                  {csvSupplierCount} suppliers
                  {lastUploadTime && ` at ${lastUploadTime}`}
                </div>
              </div>}
            {erpSynced && erpSupplierCount > 0 && <div className="mt-4 flex items-center justify-between bg-green-50 border border-green-200 rounded-lg px-4 py-2" data-id="element-902">
                <div className="flex items-center text-sm text-green-800" data-id="element-903">
                  <CheckCircleIcon size={16} className="text-green-600 mr-2" data-id="element-904" />
                  Synced from QuickBooks with {erpSupplierCount} suppliers
                </div>
              </div>}
          </div>
          <div className="overflow-x-auto" data-id="element-905">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-906">
              <thead className="bg-gray-50" data-id="element-907">
                <tr data-id="element-908">
                  <th className="px-6 py-3 text-left" data-id="element-909">
                    <input type="checkbox" checked={suppliers.length > 0 && selectedSuppliers.size === suppliers.length} onChange={handleSelectAll} disabled={suppliers.length === 0} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500 disabled:opacity-50" data-id="element-910" />
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-911">
                    Supplier Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-912">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-913">
                    Payment Terms
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-914">
                {suppliers.length === 0 ? <tr data-id="element-915">
                    <td colSpan={4} className="px-6 py-12 text-center text-sm text-gray-500" data-id="element-916">
                      Upload or sync your supplier list to start inviting
                    </td>
                  </tr> : suppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50 transition-colors" data-id="element-917">
                      <td className="px-6 py-4" data-id="element-918">
                        <input type="checkbox" checked={selectedSuppliers.has(supplier.id)} onChange={() => handleSelectSupplier(supplier.id)} className="rounded border-gray-300 text-gray-800 focus:ring-gray-500" data-id="element-919" />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-920">
                        {supplier.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-921">
                        {supplier.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-922">
                        {supplier.paymentTerms}
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        {/* Bottom: Upload or Sync Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-923">
          <div className="max-w-2xl mx-auto" data-id="element-924">
            <div className="mb-6 text-center" data-id="element-925">
              <h2 className="text-lg font-medium text-gray-900 mb-2" data-id="element-926">
                Upload or Sync Supplier List
              </h2>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-927">
              <button onClick={() => fileInputRef.current?.click()} className="inline-flex items-center justify-center px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm" data-id="element-928">
                <UploadIcon size={18} className="mr-2" data-id="element-929" />
                Upload CSV
              </button>
              <button onClick={() => setShowErpModal(true)} className="inline-flex items-center justify-center px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-930">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-931" />
                Sync from ERP
              </button>
            </div>
            <input ref={fileInputRef} type="file" accept=".csv" onChange={handleFileUpload} className="hidden" data-id="element-932" />
          </div>
        </div>
      </div>
      {/* ERP Sync Modal */}
      {showErpModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-933">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-934">
            <div className="p-6 border-b border-gray-200" data-id="element-935">
              <div className="flex items-center justify-between" data-id="element-936">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-937">
                  Sync from ERP
                </h3>
                <button onClick={() => setShowErpModal(false)} className="text-gray-400 hover:text-gray-500" data-id="element-938">
                  <XIcon size={20} data-id="element-939" />
                </button>
              </div>
            </div>
            <div className="p-6" data-id="element-940">
              <p className="text-sm text-gray-600 mb-4" data-id="element-941">
                Select your ERP system to sync supplier data
              </p>
              <div className="space-y-2" data-id="element-942">
                <button onClick={() => handleErpSync('QuickBooks')} className="w-full flex items-center justify-between px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-left" data-id="element-943">
                  <span className="text-sm font-medium text-gray-900" data-id="element-944">
                    QuickBooks
                  </span>
                  <span className="text-xs text-green-600 font-medium" data-id="element-945">
                    Active
                  </span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-946">
                  <span className="text-sm font-medium text-gray-400" data-id="element-947">
                    NetSuite
                  </span>
                  <span className="text-xs text-gray-400" data-id="element-948">Coming soon</span>
                </button>
                <button disabled className="w-full flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 cursor-not-allowed text-left" data-id="element-949">
                  <span className="text-sm font-medium text-gray-400" data-id="element-950">SAP</span>
                  <span className="text-xs text-gray-400" data-id="element-951">Coming soon</span>
                </button>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end" data-id="element-952">
              <button onClick={() => setShowErpModal(false)} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800" data-id="element-953">
                Cancel
              </button>
            </div>
          </div>
        </div>}
    </div>;
}